import {connect} from 'react-redux';
import React, {Component} from 'react';
import {actions as language} from '../reducers/language';
import ScreenHeader from '../components/general/ScreenHeader';
import Modal from '../components/general/Modal';
import { Link } from 'react-router-dom';
import _ from 'lodash';

@connect(
	state => {
		return {
			languages: state.language.languages
		}
	},
	dispatch => {
		return {
			fetchLanguages: () => dispatch(language.fetch()),
			deleteLanguage: (languageObject) => dispatch(language.delete(languageObject))
		};
	}
)
export default class LanguageList extends Component {

	componentDidMount() {
		if(this.props.languages.length === 0) {
			this.props.fetchLanguages();
		}
	}

	render() {
		const languageList = this.props.languages ? (
			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table">
							<thead>
								<tr>
									<th>Identifier (ISO-Code)</th>
									<th>Name</th>
									<th> </th>
								</tr>
							</thead>
							<tbody>
								{_.map(this.props.languages, (language, key) => (
									<tr key={key}>
										<td>{language.identifier}</td>
										<td>{language.name}</td>
										<td>
											<Link to={'/edit-language/' + encodeURIComponent(language.identifier)} className="btn btn-warning btn-link btn-icon btn-sm edit" title="edit">
												<i className="fa fa-edit"/>
											</Link>
											<button className="btn btn-danger btn-link btn-icon btn-sm"
													data-target={'#delete-modal-' + key} data-toggle="modal" type="button"
													title="delete">
												<i className="fa fa-times"/>
											</button>
											<Modal
												identifier={'delete-modal-' + key}
												callBack={() => this.props.deleteLanguage(language)}
												title="Danger Zone"
												text={'Please confirm before the language "' + language.identifier + '" is deleted.'}
												dismissText="Never mind"
												actionText="Delete"
											/>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		) : null;

		return (
			<div>
				<ScreenHeader value="Languages"/>
				{languageList}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/screens/LanguageList.js